import type { Locales } from '@monoimin/sb-types';

//Todo replace usage with getCustomFormat
export function dateFormatter(
  timestamp: string | null | undefined,
  locale: Locales
) {
  if (!timestamp) {
    return '';
  }
  try {
    const date = new Date(Date.parse(timestamp));

    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(date);
  } catch (error) {
    return '';
  }
}

export default dateFormatter;
